import React from "react"

export const ReadActivityIcon = (props: any) => (
    <svg width="20" {...props} height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.36841 8.15793V14.7895C3.36841 16.0105 4.35799 17 5.57893 17H14.421C15.642 17 16.6316 16.0105 16.6316 14.7895V8.15793"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M3.36841 8.15793V14.7895C3.36841 16.0105 4.35799 17 5.57893 17H14.421C15.642 17 16.6316 16.0105 16.6316 14.7895V8.15793"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.39915 6.51105L8.71779 3.41411C9.48779 2.86147 10.5245 2.86221 11.2945 3.41484L15.5947 6.50295C16.9719 7.49179 16.9712 9.10916 15.5933 10.0965L11.2827 13.1876C10.5127 13.7402 9.476 13.7395 8.706 13.1868L4.39768 10.0928C3.02568 9.10695 3.02642 7.49547 4.39915 6.51105Z"
            fill="#307ADE"
            fillOpacity="0.1"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.4232 10.9358V9.63161C14.4232 8.8174 13.7637 8.15793 12.9495 8.15793H7.05474C6.24053 8.15793 5.58105 8.8174 5.58105 9.63161V10.9027"
            fill="white"
        />
        <path
            d="M14.4232 10.9358V9.63161C14.4232 8.8174 13.7637 8.15793 12.9495 8.15793H7.05474C6.24053 8.15793 5.58105 8.8174 5.58105 9.63161V10.9027"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const AttachmentAddedActivityIcon = (props: any) => (
    <svg width="20" height="20" viewBox="0 0 20 20" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.0001 15.0554L8.70003 16.3556C8.28747 16.7681 7.72792 16.9999 7.14447 16.9999C6.56102 16.9999 6.00147 16.7681 5.58891 16.3556C5.17635 15.943 4.94458 15.3835 4.94458 14.8C4.94458 14.2166 5.17635 13.657 5.58891 13.2445L11.9446 6.88879"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M10.0001 15.0554L8.70003 16.3556C8.28747 16.7681 7.72792 16.9999 7.14447 16.9999C6.56102 16.9999 6.00147 16.7681 5.58891 16.3556V16.3556C5.17635 15.943 4.94458 15.3835 4.94458 14.8C4.94458 14.2166 5.17635 13.657 5.58891 13.2445L11.9446 6.88879"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.4836 9.57199V9.57199C16.987 8.06856 16.987 5.63102 15.4836 4.12759V4.12759C14.7616 3.40561 13.7824 3 12.7614 3C11.7403 3 10.7611 3.40561 10.0392 4.12759L3.38892 10.7778"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M11.1665 12.3333H14.2776" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.7222 10.7778V13.8889" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const MetaDataChangeActivityIcon = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M9.63184 10H11.8424H9.63184Z" fill="#307ADE" fillOpacity="0.1" />
        <path d="M9.63184 10H11.8424" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.63172 7.05269H5.94751" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13.316 7.05269H11.8423" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.94751 10H7.42119" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.94751 12.9474H9.63172" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.2687 16.4158L16.7844 13.9001C17.0721 13.6123 17.0721 13.1458 16.7844 12.8581L15.6158 11.6895C15.3281 11.4018 14.8615 11.4018 14.5738 11.6895L12.0581 14.2052C11.9199 14.3433 11.8423 14.5308 11.8423 14.7262V16.2632C11.8423 16.4666 12.0072 16.6316 12.2107 16.6316H13.7477C13.9431 16.6316 14.1305 16.5539 14.2687 16.4158Z"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.2632 9.26314V5.57893C16.2632 4.35809 15.2735 3.36841 14.0526 3.36841H5.21053C3.98969 3.36841 3 4.35809 3 5.57893V14.421C3 15.6419 3.98969 16.6316 5.21053 16.6316H8.89473"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M16.2632 9.26314V5.57893C16.2632 4.35809 15.2735 3.36841 14.0526 3.36841H5.21053C3.98969 3.36841 3 4.35809 3 5.57893V14.421C3 15.6419 3.98969 16.6316 5.21053 16.6316H8.89473"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const DeletedActivityIcon = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.0147 6.13428V15.3283C15.0147 16.2519 14.2667 16.9999 13.3431 16.9999H6.6565C5.73292 16.9999 4.98486 16.2519 4.98486 15.3283V6.13428"
            fill="currentColor"
            fillOpacity="0.1"
        />
        <path
            d="M15.0147 6.13428V15.3283C15.0147 16.2519 14.2667 16.9999 13.3431 16.9999H6.6565C5.73292 16.9999 4.98486 16.2519 4.98486 15.3283V6.13428"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M4.14917 6.13434H15.8507" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.5074 3.41791H7.49243" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.32807 9.47766V13.6568" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.6718 9.47766V13.6568" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const AbandonActivityIcon = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.2778 9.22222V6.75511C14.2778 6.34289 14.1137 5.947 13.822 5.65533L11.6225 3.45578C11.3308 3.16411 10.9349 3 10.5227 3H4.94447C4.08503 3 3.38892 3.69611 3.38892 4.55556V15.4444C3.38892 16.3039 4.08503 17 4.94447 17H9.61114"
            fill="#DA4FA3"
            fillOpacity="0.1"
        />
        <path
            d="M14.2778 9.22222V6.75511C14.2778 6.34289 14.1137 5.947 13.822 5.65533L11.6225 3.45578C11.3308 3.16411 10.9349 3 10.5227 3H4.94447C4.08503 3 3.38892 3.69611 3.38892 4.55556V15.4444C3.38892 16.3039 4.08503 17 4.94447 17H9.61114"
            stroke="#DA4FA3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.2778 6.88889H11.1667C10.7374 6.88889 10.3889 6.54044 10.3889 6.11111V3"
            stroke="#DA4FA3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.6109 14.2778C16.6109 15.7844 15.3953 17 13.8887 17C12.3822 17 11.1665 15.7844 11.1665 14.2778C11.1665 12.7713 12.3822 11.5556 13.8887 11.5556C15.3953 11.5556 16.6109 12.7713 16.6109 14.2778Z"
            stroke="#DA4FA3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M11.9646 16.2019L15.813 12.3535" stroke="#DA4FA3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const CreateActivityIcon = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 5.95554C3 6.42221 3.23333 6.8111 3.62222 7.12221L8.28889 10.3111C9.37778 11.0111 10.7 11.0111 11.7889 10.3111L16.4556 7.19999C16.7667 6.8111 17 6.42221 17 5.95554C17 5.17776 16.3778 4.55554 15.6 4.55554H4.4C3.62222 4.55554 3 5.17776 3 5.95554Z"
            fill="#307ADE"
            fillOpacity="0.1"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3 6.11115V13.8889C3 14.7445 3.7 15.4445 4.55556 15.4445H15.4444C16.3 15.4445 17 14.7445 17 13.8889V6.11115"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M3.45703 14.9871L8.19681 10.2473" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.8354 10.28L16.5426 14.9871" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const LaunchActivityIcon = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 5.95554C3 6.42221 3.23333 6.8111 3.62222 7.12221L8.28889 10.3111C9.37778 11.0111 10.7 11.0111 11.7889 10.3111L16.4556 7.19999C16.7667 6.8111 17 6.42221 17 5.95554C17 5.17776 16.3778 4.55554 15.6 4.55554H4.4C3.62222 4.55554 3 5.17776 3 5.95554Z"
            fill="#307ADE"
            fillOpacity="0.1"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3 6.11115V13.8889C3 14.7445 3.7 15.4445 4.55556 15.4445H15.4444C16.3 15.4445 17 14.7445 17 13.8889V6.11115"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M3.45703 14.9871L8.19681 10.2473" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.8354 10.28L16.5426 14.9871" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const CanceledActivityIcon = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M6 6L14 14L6 6Z" fill="currentColor" fillOpacity="0.1" />
        <path d="M6 6L14 14" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14 6L6 14" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const CompletedActivityIcon = (props: any) => (
    <svg width="20" {...props} height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.2143 8.84443V4.96484V8.84443Z"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path d="M16.2143 8.84443V4.96484" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.1034 13.4885L11.5479 15.0437L13.1034 16.599"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M13.1034 13.4885L11.5479 15.0437L13.1034 16.599"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.6581 3.40106H4.56411C3.7 3.40106 3 4.10093 3 4.96487C3 5.48355 3.25744 5.96802 3.68678 6.25885L7.85333 9.08242C8.915 9.80173 10.3088 9.80173 11.3704 9.08242L15.5362 6.25963C15.9648 5.96879 16.2222 5.48355 16.2222 4.96565V4.96487C16.2222 4.10093 15.5222 3.40106 14.6581 3.40106Z"
            fill="#307ADE"
            fillOpacity="0.1"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.22222 13.5102H4.55556C3.69611 13.5102 3 12.8142 3 11.9549V4.96484"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M9.22222 13.5102H4.55556C3.69611 13.5102 3 12.8142 3 11.9549V4.96484"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.6667 11.955H15.4445C16.304 11.955 17.0001 12.6509 17.0001 13.5102C17.0001 14.3695 16.304 15.0655 15.4445 15.0655H15.0634H15.4445H11.5479"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M14.6667 11.955H15.4445C16.304 11.955 17.0001 12.6509 17.0001 13.5102V13.5102C17.0001 14.3695 16.304 15.0655 15.4445 15.0655H15.0634H15.4445H11.5479"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ChangeChorusStatusActivityIcon = (props: any) => (
    <svg width="20" {...props} height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 9.50134L16 8.50134L17 9.50134"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path d="M15 9.50134L16 8.50134L17 9.50134" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5 10.5012L4 11.5012L3 10.5012" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.00008 12.3346V9.28125" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.0001 12.3346V9.28125" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.0001 12.3346V9.28125" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.33301 12.3347H12.6663" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.33301 8.09255V9.28122H12.6663V8.09255L9.99967 7.00122L7.33301 8.09255Z"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.15158 11.3267C4.05558 10.9 4.00024 10.4573 4.00024 10.0013C4.00024 6.68801 6.68691 4.00134 10.0002 4.00134C12.0169 4.00134 13.7936 5.00201 14.8816 6.52801"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.8513 8.67328C15.9473 9.09995 16.0027 9.54261 16.0027 9.99861C16.0027 13.3119 13.316 15.9986 10.0027 15.9986C7.98534 15.9986 6.20867 14.9979 5.12134 13.4719"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const SendToChorusActivityIcon = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M4.40029 14.2V7.90002V14.2Z" fill="#307ADE" fillOpacity="0.1" />
        <path d="M4.40029 14.2V7.90002" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15.6 7.90002V14.2" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.19985 7.90002V14.2" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.0001 7.90002V14.2" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.7997 7.90002V14.2" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M9.9997 5.99236C9.9514 5.99236 9.9122 6.03156 9.9129 6.07986C9.9129 6.12816 9.9521 6.16736 10.0004 6.16736C10.0487 6.16736 10.0879 6.12816 10.0879 6.07986C10.0872 6.03156 10.048 5.99236 9.9997 5.99236"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.6499 7.90001H3.34985V6.05271L9.99985 3.70001L16.6499 6.05271V7.90001Z"
            fill="#307ADE"
            fillOpacity="0.1"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.3 14.2H3.7L3 14.9V16.3H17V14.9L16.3 14.2Z"
            fill="#307ADE"
            fillOpacity="0.1"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const RoutingActivityIcon = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.2219 4.953V10.3889" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16.9999 15.0556H12.3333" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M15.4443 13.5002L16.9999 15.0557L15.4443 16.6113"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.22222 13.5H4.55556C3.69611 13.5 3 12.8039 3 11.9444V4.953"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M9.22222 13.5H4.55556C3.69611 13.5 3 12.8039 3 11.9444V4.953"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.56411 3.38892H14.6589C15.5222 3.38892 16.223 4.08892 16.223 4.95303C16.223 5.4718 15.9656 5.95636 15.5362 6.24725L11.3697 9.07136C10.308 9.7908 8.91422 9.7908 7.85256 9.07136L3.68678 6.24803C3.25744 5.95714 3 5.4718 3 4.9538V4.95303C3 4.08892 3.7 3.38892 4.56411 3.38892Z"
            fill="#307ADE"
            fillOpacity="0.1"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ExternalProcessActivityIcon = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle
            cx="10.0001"
            cy="15.865"
            r="1.13514"
            fill="#307ADE"
            fillOpacity="0.1"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.78384 12.081C5.00758 12.081 3.56763 10.6411 3.56763 8.86481L6.78384 12.081Z"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M6.78384 12.081C5.00758 12.081 3.56763 10.6411 3.56763 8.86481"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.7839 6.78369C15.2467 6.78369 16.4326 7.96953 16.4326 9.43234C16.4326 10.8951 15.2467 12.081 13.7839 12.081"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M13.7839 6.78369C15.2467 6.78369 16.4326 7.96953 16.4326 9.43234C16.4326 10.8951 15.2467 12.081 13.7839 12.081"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.99951 3C11.003 3 11.9655 3.39865 12.6751 4.10824C13.3846 4.81784 13.7833 5.78026 13.7833 6.78378"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M9.99951 3C11.003 3 11.9655 3.39865 12.6751 4.10824C13.3846 4.81784 13.7833 5.78026 13.7833 6.78378"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M11.135 15.8648H16.0539" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3.94629 15.8648H8.86521" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.99996 12.0963V14.7298" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.39595 5.68781C4.78512 5.87868 3.57075 7.24279 3.56763 8.8649L6.39595 5.68781Z"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M6.39595 5.68781C4.78512 5.87868 3.57075 7.24279 3.56763 8.8649"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.99941 3C8.3372 3.00391 6.87355 4.09564 6.396 5.68777L9.99941 3Z"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M9.99941 3C8.3372 3.00391 6.87355 4.09564 6.396 5.68777"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M13.7839 12.0811H6.78394" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const PostalStatusUpdatedActivityIcon = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.1564 5.59201C12.4591 5.89471 12.5347 6.27309 12.4591 6.57579L11.6266 10.965C11.3996 12.0244 10.5672 12.8569 9.5077 13.0839L5.11851 13.9163C4.74014 13.992 4.36176 13.8407 4.13473 13.6136C3.68068 13.1596 3.68068 12.4785 4.13473 12.0244L10.5672 5.59201C10.9455 5.13795 11.7023 5.13795 12.1564 5.59201Z"
            fill="#307ADE"
            fillOpacity="0.1"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.91866 3.62435C7.89747 3.62435 7.88082 3.6077 7.88082 3.58651C7.88082 3.56532 7.89747 3.54867 7.91866 3.54867C7.93985 3.54867 7.9565 3.56532 7.9565 3.58651C7.9565 3.6077 7.93985 3.62435 7.91866 3.62435"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M3.37842 16.4135H17" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3.37838 5.81892V3.54865" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.64889 4.3054V3.54865" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.1569 5.59174L16.092 9.52687C16.6974 10.1323 16.6974 11.0404 16.092 11.6458L11.3245 16.4134"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M12.1569 5.59174L16.092 9.52687C16.6974 10.1323 16.6974 11.0404 16.092 11.6458L11.3245 16.4134"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M4.05957 13.6893L6.85957 16.4137" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const ProcessingActivityIcon = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 5.95554C3 6.42221 3.23333 6.8111 3.62222 7.12221L8.28889 10.3111C9.37778 11.0111 10.7 11.0111 11.7889 10.3111L16.4556 7.19999C16.7667 6.8111 17 6.42221 17 5.95554C17 5.17776 16.3778 4.55554 15.6 4.55554H4.4C3.62222 4.55554 3 5.17776 3 5.95554Z"
            fill="#307ADE"
            fillOpacity="0.1"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3 6.11115V13.8889C3 14.7445 3.7 15.4445 4.55556 15.4445H15.4444C16.3 15.4445 17 14.7445 17 13.8889V6.11115"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M3.45703 14.9871L8.19681 10.2473" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.8354 10.28L16.5426 14.9871" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const SignActivityIcon = (props: any) => (
    <svg width="20" {...props} height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.88892 11.1378V16.9999L10 15.4443L13.1111 16.9999V11.1378"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M6.88892 11.1378V16.9999L10 15.4443L13.1111 16.9999V11.1378"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.2997 4.36684C15.1222 6.18929 15.1222 9.14406 13.2997 10.9665C11.4773 12.7889 8.52253 12.7889 6.70009 10.9665C4.87764 9.14405 4.87764 6.18928 6.70009 4.36684C8.52254 2.54439 11.4773 2.54439 13.2997 4.36684"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M13.2997 4.36684C15.1222 6.18929 15.1222 9.14406 13.2997 10.9665C11.4773 12.7889 8.52253 12.7889 6.70009 10.9665C4.87764 9.14405 4.87764 6.18928 6.70009 4.36684C8.52254 2.54439 11.4773 2.54439 13.2997 4.36684"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const ArchiveActivityIcon = (props: any) => (
    <svg width="20" {...props} height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.3 6.5H3.7C3.3136 6.5 3 6.1864 3 5.8V4.4C3 4.0136 3.3136 3.7 3.7 3.7H16.3C16.6864 3.7 17 4.0136 17 4.4V5.8C17 6.1864 16.6864 6.5 16.3 6.5Z"
            fill="#307ADE"
            fillOpacity="0.1"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M7.90015 9.3H12.1001Z" fill="#307ADE" fillOpacity="0.1" />
        <path d="M7.90015 9.3H12.1001" stroke="#307ADE" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.0669 6.49996V14.9C16.0669 15.6735 15.4404 16.3 14.6669 16.3H5.33311C4.55961 16.3 3.93311 15.6735 3.93311 14.9V6.49996"
            fill="#307ADE"
            fillOpacity="0.1"
        />
        <path
            d="M16.0669 6.49996V14.9C16.0669 15.6735 15.4404 16.3 14.6669 16.3H5.33311C4.55961 16.3 3.93311 15.6735 3.93311 14.9V6.49996"
            stroke="#307ADE"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const SendActivityIcon = (props: any) => (
    <svg width="20" {...props} height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.37159 9.33092L8.76407 15.5967C8.93784 16.3775 9.97493 16.5457 10.3861 15.8601L16.8721 5.04969C17.2267 4.45999 16.8021 3.70989 16.1141 3.70989H3.88685C3.09822 3.70989 2.70351 4.66285 3.26098 5.22031L7.37159 9.33092Z"
            fill="currentColor"
            fillOpacity="0.1"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.8746 4.15017L7.36865 9.33168Z"
            fill="currentColor"
            fillOpacity="0.1"
        />
        <path d="M16.8746 4.15017L7.36865 9.33168" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const ErrorActivityIcon = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 3C13.8663 3 17 6.13367 17 10C17 13.8663 13.8663 17 10 17C6.13367 17 3 13.8663 3 10C3 6.13367 6.13367 3 10 3Z"
            fill="currentColor"
            fillOpacity="0.1"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M10.0002 10.3889V6.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M9.99944 13.1111C9.89211 13.1111 9.805 13.1982 9.80578 13.3055C9.80578 13.4128 9.89289 13.5 10.0002 13.5C10.1076 13.5 10.1947 13.4128 10.1947 13.3055C10.1947 13.1982 10.1076 13.1111 9.99944 13.1111"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const PostalActivityIcon = (props: any) => (
    <svg width="20" height="20" {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 3V3C13.8663 3 17 6.13367 17 10V10C17 13.8663 13.8663 17 10 17V17C6.13367 17 3 13.8663 3 10V10C3 6.13367 6.13367 3 10 3Z"
            fill="#DA4FA3"
            fillOpacity="0.1"
            stroke="#DA4FA3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M10.0002 10.3889V6.5Z" fill="#DA4FA3" fillOpacity="0.1" />
        <path d="M10.0002 10.3889V6.5" stroke="#DA4FA3" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.99944 13.111C9.89211 13.111 9.805 13.1982 9.80578 13.3055C9.80578 13.4128 9.89289 13.4999 10.0002 13.4999C10.1076 13.4999 10.1947 13.4128 10.1947 13.3055C10.1947 13.1982 10.1076 13.111 9.99944 13.111"
            fill="#DA4FA3"
            fillOpacity="0.1"
        />
        <path
            d="M9.99944 13.111C9.89211 13.111 9.805 13.1982 9.80578 13.3055C9.80578 13.4128 9.89289 13.4999 10.0002 13.4999C10.1076 13.4999 10.1947 13.4128 10.1947 13.3055C10.1947 13.1982 10.1076 13.111 9.99944 13.111"
            stroke="#DA4FA3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const NumeriaIdIcon = (props: any) => (
    <svg width="12" height="12" {...props} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1 7L2.27527 4.87456C2.42204 4.62993 2.63553 4.43224 2.89068 4.30466L3.18328 4.15836C3.39156 4.05422 3.62123 4 3.8541 4H4.5"
            stroke="currentColor"
            strokeOpacity="0.7"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1 7L2.27527 4.87456C2.42204 4.62993 2.63553 4.43224 2.89068 4.30466L3.18328 4.15836C3.39156 4.05422 3.62123 4 3.8541 4H4.5"
            stroke="currentColor"
            strokeOpacity="0.2"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.11003 6.39C4.73528 6.21029 4.49773 5.83061 4.50002 5.415V2.5C4.50002 1.94772 4.94775 1.5 5.50003 1.5H10C10.5523 1.5 11 1.94772 11 2.5V5.5C11 6.05228 10.5523 6.5 10 6.5H7.32411"
            stroke="currentColor"
            strokeOpacity="0.7"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.11003 6.39C4.73528 6.21029 4.49773 5.83061 4.50002 5.415V2.5C4.50002 1.94772 4.94775 1.5 5.50003 1.5H10C10.5523 1.5 11 1.94772 11 2.5V5.5C11 6.05228 10.5523 6.5 10 6.5H7.32411"
            stroke="currentColor"
            strokeOpacity="0.2"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.51074 2.39279L6.95053 3.79947C7.41424 4.06683 7.98529 4.06683 8.449 3.79947L10.9836 2.3381"
            stroke="currentColor"
            strokeOpacity="0.7"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.51074 2.39279L6.95053 3.79947C7.41424 4.06683 7.98529 4.06683 8.449 3.79947L10.9836 2.3381"
            stroke="currentColor"
            strokeOpacity="0.2"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M2 10.4999L4.88093 9.45893C5.28304 9.31363 5.62799 9.0433 5.8652 8.6876L7.36164 6.44362C7.57929 6.11724 7.53629 5.68261 7.25889 5.40522V5.40522C6.93759 5.08391 6.41667 5.08386 6.0953 5.4051L5 6.49993H4"
            stroke="currentColor"
            strokeOpacity="0.7"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M2 10.4999L4.88093 9.45893C5.28304 9.31363 5.62799 9.0433 5.8652 8.6876L7.36164 6.44362C7.57929 6.11724 7.53629 5.68261 7.25889 5.40522V5.40522C6.93759 5.08391 6.41667 5.08386 6.0953 5.4051L5 6.49993H4"
            stroke="currentColor"
            strokeOpacity="0.2"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const CopyIcon = (props: any) => (
    <svg width="14" height="14" {...props} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
            x="4.22205"
            y="4.22223"
            width="7.77796"
            height="7.77796"
            rx="2"
            stroke="white"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.22227 9.77784H3.11114C2.49747 9.77784 2 9.28037 2 8.6667V3.11102C2 2.49735 2.49747 1.99988 3.11114 1.99988H8.66683C9.28049 1.99988 9.77796 2.49735 9.77796 3.11102V4.22215"
            stroke="white"
            strokeWidth="0.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
